import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import ar from "./locales/ar.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";

export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const getTemplateName = () => {
  return import.meta.env.VITE_TEMPLATE_NAME;
};

export const getSMTPConfigId = () => {
  return import.meta.env.VITE_SMTP_CONFIG_ID;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      fr: {
        translation: fr,
      },
      ar: {
        translation: ar,
      },
    },
    lng: "fr",
    fallbackLng: "fr",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Only restore a saved preference from localStorage — never auto-detect from browser locale.
      // This ensures the default language is always French (lng: "fr") on first load.
      order: ["localStorage"],
      caches: ["localStorage"],
    },
  });

export default i18n;
